<template>
  <div class="self-stretch flex-col justify-start items-start gap-5 md:gap-3 flex">
    <SummaryListItem
      v-for="(item, itemIndex) in reviewSummary.items"
      :key="itemIndex"
      :item="item"
      :isLastReviewSummaryItem="itemIndex === reviewSummary.items.length - 1"
    >
      <template #edit>
        <Link v-if="item.editUrl && item.showEdit" :field="formatLink(item.editUrl)" class="text-base-bold">Edit</Link>
        <button
          v-if="item.editGoToStep != null && item.showEdit"
          type="button"
          class="link text-base-bold"
          @click="onEditDetails(item.editGoToStep, reviewSummary, item)"
        >
          Edit
        </button>
        <div v-if="itemIndex === reviewSummary.items.length - 1" class="w-[28px]"></div>
      </template>
    </SummaryListItem>
  </div>
</template>

<script setup lang="ts">
import { IReviewSummary, IReviewSummaryItem } from '@/interfaces';
import SummaryListItem from './SummaryListItem.vue';
import { useFormStore } from '@/store';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';

const formStore = useFormStore();

defineProps<{
  reviewSummary: IReviewSummary;
}>();

// Exposed to track which "edit" link was clicked from the ReviewSummary
const emit = defineEmits<(e: 'editClicked', summary: IReviewSummary, item: IReviewSummaryItem) => void>();
function onEditDetails(goToStep: number, reviewSummary: IReviewSummary, reviewSummaryItem: IReviewSummaryItem) {
  emit('editClicked', reviewSummary, reviewSummaryItem);
  formStore.goToStep(goToStep);
}

function formatLink(url: string): LinkField {
  return {
    value: {
      href: url,
      target: '_self',
    },
  };
}
</script>
